export default {
  getShipHeroShipmentResults(state) {
    return state.shipHeroShipmentResults;
  },

  getTrackingDetailsData(state) {
    return state.trackingDetailsForShipHeroOrder;
  },

  getQuickEditStatus(state) {
    return state.quickEditActive;
  },

  getShipHeroDataStatus(state) {
    return state.shipHeroDataExists;
  },


};
